import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';
import {IPhrase} from '../_interface/phrases.model';
import {DocumentationPhraseDto} from 'app/_models/model/documentationPhraseDto';

export const getPhrases = createAction(
	'[Phrases] Get Phrases'
);

export const loadPhrases = createAction(
	'[Phrases] Load Phrases',
	props<{ phrases: DocumentationPhraseDto[] }>()
);

export const addPhrases = createAction(
	'[Phrases] Add Phrases',
	props<{ phrases: DocumentationPhraseDto }>()
);

export const upsertPhrase = createAction(
	'[Phrases] Upsert Phrase',
	props<{ phrase: DocumentationPhraseDto }>()
);

export const addPhrasess = createAction(
	'[Phrases] Add Phrases',
	props<{ phrasess: DocumentationPhraseDto[] }>()
);

export const upsertPhrasess = createAction(
	'[Phrases] Upsert Phrases',
	props<{ phrasess: DocumentationPhraseDto[] }>()
);

export const updatePhrases = createAction(
	'[Phrases] Update Phrases',
	props<{ phrases: Update<DocumentationPhraseDto> }>()
);

export const updatePhrasess = createAction(
	'[Phrases] Update Phrases',
	props<{ phrasess: Update<DocumentationPhraseDto>[] }>()
);

export const tryDeletePhrase = createAction(
	'[Phrases] Try Delete Phrase',
	props<{ phraseId: string }>()
);

export const deletePhrase = createAction(
	'[Phrases] Delete Phrase',
	props<{ phraseId: string }>()
);

export const deletePhrases = createAction(
	'[Phrases] Delete Phrases',
	props<{ ids: string[] }>()
);

export const clearPhrases = createAction(
	'[Phrases] Clear Phrases'
);

export const editPhrase = createAction(
	'[Phrases] Edit Phrase',
	props<{phraseId: string}>()
);

export const createPhrase = createAction(
	'[Phrases] Create Phrase',
	props<{templateFieldId: string}>()
);

export const prepareEmptyPhrase = createAction(
	'[Phrases] Prepare Empty Phrase',
	props<{phrase: DocumentationPhraseDto}>()
);

export const openPhraseModal = createAction(
	'[Phrases] Open create/edit modal'
);

export const submitEditPhrase = createAction(
	'[Phrases] Submit edit phrase',
	props<{phrase: Partial<IPhrase>}>()
);

export const cancelEditPhrase = createAction(
	'[Phrases] Cancel edit phrase'
);
